export default {"src":"/_next/static/media/send-to-mobile.bd6642fc.svg","height":32,"width":24,"blurWidth":0,"blurHeight":0};